/** Created by atartanian on 4/11/16 */
/**
 * Usage:
 *
 *  data-sw-shop-section-edit-item
 *
 *  container for all the fields associated with an individual shop section edit element
 *
 *
 *  data-sw-shop-section-edit-item-title
 *
 *  the input field that has the shop section title
 *
 *
 *  data-sw-shop-section-edit-item-id
 *
 *  the input field that has the shop section id
 *
 *
 *  data-sw-shop-section-edit-item-active
 *
 *  the input field that has the shop section active state
 *
 *
 *  data-sw-shop-section-edit-delete
 *
 *  the element that triggers deleting a shop section
 *
 *
 *  data-sw-shop-section-edit-add-input
 *
 *  the input field that is used to add a new section
 *
 *
 *  data-sw-shop-section-edit-add
 *
 *  the element that triggers adding a new section
 *
 */

var $ = require('js/sw-jquery/sw-jquery');

module.exports = function($fragment) {

  require([
    'js/lib/views/ShopSectionEditView'
  ], function(ShopSectionEditView) {


    $fragment.swFindWithSelf('[data-sw-shop-section-edit]').each(function() {

      var $el = $(this);

      new ShopSectionEditView({
        el:   $el
      });

    });

  });

};

